import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { variant: String }

  track() {
    if (typeof window.gtag !== "function") return

    window.gtag("event", "support_click", {
      cta_variant: this.variantValue || "unknown",
      page_location: window.location.href
    })
  }
}
